import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { QueryProvider } from './providers/QueryProvider'
import { SettingsProvider } from './contexts/SettingsContext'
import { OnboardingProvider } from './contexts/OnboardingContext'
import { AuthProvider } from './contexts/AuthContext'
import { TeamProvider } from './contexts/TeamContext'
import { ErrorReporterProvider } from './contexts/ErrorReporterContext'
import { ErrorReportDialog } from './components/shared/ErrorReportDialog'
import { ErrorBoundaryWithReporter } from './components/shared/ErrorBoundary'
import { routes } from './router/routes'
import './index.css'

const router = createBrowserRouter(routes)

export default function App() {
	return (
		<QueryProvider>
			<SettingsProvider>
				<OnboardingProvider>
					<AuthProvider>
						<ErrorReporterProvider>
							<TeamProvider>
								<ErrorBoundaryWithReporter>
									<RouterProvider router={router} />
								</ErrorBoundaryWithReporter>
							</TeamProvider>
							<ErrorReportDialog />
						</ErrorReporterProvider>
					</AuthProvider>
				</OnboardingProvider>
			</SettingsProvider>
		</QueryProvider>
	)
}
